import { css, cx } from '@linaria/atomic';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Button, Text } from '@frontend/design-system';
import { draggableStyles } from './styles';

const warningTooltipDivStyle2 = css`
  display: flex;
  align-items: flex-start;
  gap: ${theme.spacing(1)};
`;

const warningTooltipIconStyle3 = css`
  flex-shrink: 0;
  margin-top: 2px;
`;

const warningTooltipTextStyle4 = css`
  color: ${theme.font.colors.default};
`;

const ARROW_SIZE = 8;

const warningTooltipDivStyle1 = css`
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-left: ${ARROW_SIZE + 4}px;
  background: ${theme.colors.warning5};
  border: 1px solid ${theme.colors.warning50};
  border-radius: ${theme.borderRadius.medium};
  max-width: 224px;
  width: max-content;
  padding: ${theme.spacing(1, 1.5)};

  // Arrow pointing left
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    right: 100%;
    transform: translateY(-50%);
    border: ${ARROW_SIZE}px solid transparent;
    border-right-color: ${theme.colors.warning50};
  }
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    right: 100%;
    transform: translateY(-50%);
    border: ${ARROW_SIZE - 1}px solid transparent;
    border-right-color: ${theme.colors.warning5};
    margin-right: -1px;
  }
`;

type WarningTooltipProps = {
  message: string;
  onDismiss?: () => void;
};

export const WarningTooltip = ({ message, onDismiss }: WarningTooltipProps) => {
  return (
    <div className={cx(warningTooltipDivStyle1, draggableStyles)}>
      <div className={warningTooltipDivStyle2}>
        <Icon name='alert-filled' size={16} className={warningTooltipIconStyle3} />
        <Text size='small' className={warningTooltipTextStyle4}>
          {message}
        </Text>
        <Button
          aria-label='Dismiss warning'
          variant='secondary'
          size='tiny'
          iconName='x'
          onClick={(e) => {
            e.stopPropagation();
            onDismiss?.();
          }}
        />
      </div>
    </div>
  );
};
